import { SidebarProvider, SidebarTrigger } from "./ui/sidebar";

/**
 * Layout component that provides a sidebar structure
 * @param children - Array of React nodes where:
 *   - children[0]: The sidebar content (navigation, filters, etc.)
 *   - children[1]: The main content to be displayed in the content area
 */
export default function LayoutSidebar({
  sidebar,
  main,
  tools,
}: {
  sidebar: React.ReactNode;
  main: React.ReactNode;
  tools: React.ReactNode;
}) {
  return (
    <SidebarProvider>
      {sidebar}
      <main className="w-full relative h-dvh">
        <SidebarTrigger className="absolute top-4 left-4 z-50" />
        {main}
        {tools}
      </main>
    </SidebarProvider>
  );
}
